
import React, {useRef} from 'react';
import {useParams} from "react-router-dom";
import {Table} from "antd";

import {useApiSearchTeacherStudents} from "@/api/userAcademy";
import TeacherPrintListHeader from "@/pages/teacher/lessons/[id]/print/_section/TeacherListPrintHeader";
import {useApiReadTeacherLessonDetail} from "@/api/lesson";
import RenderLoading from "@/components/render-if-loading";
import RenderIf from "@/components/render-if";

function TeacherStudentListPrintPage() {
    const {id} = useParams();

    const {data: lessonDetail, isPending: isPendingLoadLesson} = useApiReadTeacherLessonDetail(id);

    const contentRef = useRef(null);
    const {data: students, isPending} = useApiSearchTeacherStudents({lesson_id: id, per_page: 1000});

    const attendanceColumns = [];
    for (let i = 1; i <= 12; i++) {
        attendanceColumns.push({
            title: ` `,
            dataIndex: `session${i}`,
            key: `session${i}`,
            width: 5,
            align: 'center',
            render: () => <span style={{fontSize: '5px'}}></span>,
        });
    }

    let i = 1;
    const columns = [
        {
            title: '#',
            dataIndex: 'studentId',
            key: 'studentId',
            width: 50,
            align: 'center',
            fixed: 'left',
            render: (text, record) => i++,
        },
        {
            title: 'کد',
            dataIndex: 'studentnumber',
            key: 'studentnumber',
            width: 40,
            align: 'right',
            fixed: 'left',
            render: (text, record) => record?.student_detail?.code,
        },
        {
            title: 'نام و نام خانوادگی',
            dataIndex: 'name',
            key: 'name',
            width: 180,
            align: 'right',
            fixed: 'left',
            render: (text, record) => (
                (record?.student_detail?.firstname ?? '') + ' ' +
                (record?.student_detail?.lastname ?? '')
            ),
        },
        {
            title: 'موبایل',
            dataIndex: 'mobile',
            key: 'mobile',
            width: 50,
            align: 'right',
            fixed: 'left',
            render: (text, record) => (
                <>
                    <RenderIf condition={record?.student_detail?.mobile}>
                        {record?.student_detail?.mobile}
                    </RenderIf>

                    <RenderIf condition={record?.student_detail?.parent_detail?.mobile}>
                        {record?.student_detail?.parent_detail?.mobile}
                    </RenderIf>
                </>
            ),
        },
        {
            title: 'کدملی',
            dataIndex: 'nationalcode',
            key: 'nationalcode',
            width: 50,
            align: 'right',
            fixed: 'left',
            render: (text, record) => record?.student_detail?.nationalcode ?? '',
        },
        ...attendanceColumns,
    ];

    return (
        <>
            <div
                ref={contentRef}
                className="mx-auto bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 shadow-sm print:shadow-none"
                style={{
                    width: '210mm',
                    minHeight: '297mm',
                    margin: '0 auto',
                    padding: '5mm',
                    direction: 'rtl',
                    fontFamily: 'Tahoma, sans-serif',
                }}
            >
                <RenderLoading loading={isPendingLoadLesson} skeleton={true}>
                    <TeacherPrintListHeader
                        classInfo={lessonDetail?.data?.data}
                        contentRef={contentRef}
                    />
                </RenderLoading>

                <RenderLoading loading={isPending} skeleton={true}>
                    <div className="rounded-lg  border border-gray-200 dark:border-gray-700">
                        <Table
                            columns={columns}
                            dataSource={students?.data?.data}
                            pagination={false}
                            bordered
                            size="small"
                            scroll={{x: 'max-content'}}
                            className="dark-table"
                            style={{
                                fontSize: '12px',
                            }}
                        />
                    </div>
                </RenderLoading>
            </div>
        </>
    );
}

export default TeacherStudentListPrintPage;
